import { Text, Box, Tooltip, Flex } from '@chakra-ui/react';
import { CustomEditableControls } from "./CustomEditableControls";
import { useCallback, useEffect, useRef, useState } from 'react';
import { useHandleClickOutside } from '../hooks/useHandleClickOutside';
import { EditableContext } from './EditableTinySelect';
import { parse } from 'BrokerTsLib/src/Utils/formatInputs';
import { priceFormat } from 'BrokerTsLib/src/Utils/formatPrice';
import { CustomNumberInput } from './CustomNumberInput';

type EditableNumberProps = {
  value?: number | string
  text?: string
  onSubmit: (limit: number) => void
  min?: number
  max?: number
  isDisabled?: boolean
  unit?: string
  errorMessage?: string
  editing?: boolean
  tooltip?: string
}

export const EditablePriceCustom = ({ value, text, onSubmit, min, max, isDisabled, unit, errorMessage, tooltip, editing = false }: EditableNumberProps) => {
  const [isEditing, setIsEditing] = useState(editing)
  const [inputVal, setInputVal] = useState<number | undefined>(!!value || value == 0 ? parseInt(parse(value.toString())) : undefined)

  const [error, setError] = useState(errorMessage)

  useEffect(() => {
    setError(error)
  }, [errorMessage])

  useEffect(() => {
    setIsEditing(editing)
  }, [editing])

  // v pripade chyby chceme nechat editaci otevrenou
  useEffect(() => {
    if (!!error)
      setIsEditing(true)
  }, [!!error])

  const formatValue = (value?: number) => {
    if (unit && unit == '%')
      return `${value}${unit ?? ''}`

    return priceFormat(value, undefined, '0 Kč')
  }

  const submit = useCallback(() => {
    const num = inputVal ?? 0
    if (min && num < min) {
      setError('Minimální možná hodnota je ' + formatValue(min))
      return
    }

    if (max && num > max) {
      setError('Maximální možná hodnota je ' + formatValue(max))
      return
    }

    setIsEditing(false)
    onSubmit(num)
  }, [inputVal])

  const ref = useRef<HTMLInputElement>(null)
  useHandleClickOutside(ref, () => {
    submit()
  })

  const textSx = { p: 0, fontSize: 'xs' }

  return (
    <EditableContext.Provider value={{
      isEditing: isEditing,
      setIsEditing: setIsEditing
    }}>
      <form onSubmit={(e) => {
        e.preventDefault()
        submit()
      }}>
        <Box sx={{ display: 'flex', gap: 1 }}>
          {!isEditing &&
            <Tooltip label={tooltip}>
              <Text sx={{ p: 0, fontSize: 'sm', textDecoration: 'underline', textDecorationStyle: 'dotted', color: !!error ? 'red.500' : '' }} >
                {text}
              </Text>
            </Tooltip>
          }

          {isEditing &&
            <Tooltip label={error}>
              <Flex gap={2} whiteSpace='nowrap'>
                {(!!min || min === 0) && (!!max || max === 0) && isEditing &&
                  <Text sx={{ ...textSx }}>
                    {formatValue(min)} - {formatValue(max)}
                  </Text>
                }

                <CustomNumberInput
                  // w={48}
                  ref={ref}
                  defaultValue={inputVal}
                  onValueChange={(val, value) => setInputVal(value)}
                  inputRightElement=''
                  // isDisabled={isContracted}            
                  inputProps={{
                    sx: {
                      w: 'auto', maxW: '100px', py: 0.25, bg: 'white', fontSize: 'sm', height: 'auto', lineHeight: '19px', textAlign: 'end'
                    }
                  }}
                />
              </Flex>
            </Tooltip>
          }

          {!isDisabled && <CustomEditableControls />}
        </Box>
      </form>
    </EditableContext.Provider>
  );
};